import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2, Headphones } from "lucide-react";

export const FooterCTA = ({
  onBuy,
  onEnterStudio,
  isPaying = false,
  hasActiveEntitlement = false,
  isEntitlementLoading = false,
}) => {
  const ctaDisabled = isPaying || isEntitlementLoading;

  return (
    <>
      <section
        data-testid="footer-cta"
        className="relative py-32 md:py-40 px-6 md:px-12 lg:px-16 overflow-hidden border-t border-white/[0.06]"
      >
        {/* Gold radial glow */}
        <div
          aria-hidden
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "radial-gradient(ellipse at center, rgba(197,160,89,0.08) 0%, transparent 60%)",
          }}
        />

        <div className="relative max-w-5xl mx-auto text-center">
          <div className="text-xs uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-6">
            {hasActiveEntitlement
              ? "Your studio is ready"
              : "Your turn behind the console"}
          </div>
          <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl font-bold tracking-tighter text-white leading-[1.02]">
            {hasActiveEntitlement ? "Continue your mixing" : "Start your mixing"}
            <br />
            <span className="gold-text italic font-light">
              {hasActiveEntitlement ? "inside the studio." : "journey today."}
            </span>
          </h2>
          <p className="mt-8 max-w-2xl mx-auto text-zinc-400 text-base md:text-lg leading-relaxed">
            {hasActiveEntitlement
              ? "Your account has access to the masterclass. Jump back into the protected lessons and keep refining the chain."
              : "Join hundreds of producers and engineers who are already mixing radio-ready vocals at home."}
          </p>
          <div className="mt-12">
            <button
              data-testid="footer-buy-subscription"
              onClick={hasActiveEntitlement ? onEnterStudio : onBuy}
              disabled={ctaDisabled}
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#C5A059] text-black font-medium text-sm tracking-wide hover:bg-[#E5BE6B] transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-70 disabled:hover:scale-100 shadow-[0_10px_50px_-10px_rgba(197,160,89,0.5)]"
            >
              {hasActiveEntitlement ? (
                <>
                  Enter Studio
                  <Headphones className="w-4 h-4" strokeWidth={2} />
                </>
              ) : (
                <>
                  {isEntitlementLoading
                    ? "Checking access..."
                    : isPaying
                      ? "Opening checkout..."
                      : "Buy Now"}
                  <ArrowUpRight
                    className="w-4 h-4 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"
                    strokeWidth={2}
                  />
                </>
              )}
            </button>
          </div>
          {hasActiveEntitlement && (
            <div className="mt-5 inline-flex items-center gap-2 rounded-full border border-[#C5A059]/25 bg-[#C5A059]/10 px-4 py-2 text-sm font-medium text-[#E3C985]">
              <CheckCircle2 className="h-4 w-4" />
              Access granted
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/[0.06] px-6 md:px-12 lg:px-16 py-12">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-lg bg-[#C5A059]/10 border border-[#C5A059]/30 flex items-center justify-center">
              <Headphones className="w-4 h-4 text-[#C5A059]" strokeWidth={1.6} />
            </span>
            <span className="font-heading text-lg font-semibold tracking-tight text-white">
              Kiru<span className="text-[#C5A059]">·</span>beezy
            </span>
          </div>
          <div className="flex flex-wrap items-center gap-x-8 gap-y-3 text-sm text-zinc-500">
            <Link to="/privacy" className="hover:text-zinc-200 transition-colors">
              Privacy
            </Link>
            <Link to="/terms" className="hover:text-zinc-200 transition-colors">
              Terms
            </Link>
            <Link to="/contact" className="hover:text-zinc-200 transition-colors">
              Contact
            </Link>
            <span>© 2026 Kirubeezy Studios</span>
          </div>
        </div>
      </footer>
    </>
  );
};
